// @flow strict-local

import * as React from 'react';
import useI18n from 'src/hooks/useI18n';

import * as api from 'src/utils/api-no-store';
import {
  NoAvailabilityPage,
  NoAvailabilitySuccess,
  BookingHeader,
} from './common.jsx';
import {BookingDetailsForm} from './confirm-details.jsx';


export default function NoAvailability({
  templateId,
  color,
  sessionId,
}: {
  templateId: string,
  color?: ?string,
  sessionId?: string,
}): React.Node {
  const [page, setPage] = React.useState('start');
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;

  const handleSubmit = async (details) => {
    await api.post(`scheduler/event-template/${templateId}/no-availability`, {
      guest_name: details.name,
      guest_email: details.email,
      guest_phone: details.phone,
      session_id: sessionId,
    });
    setPage('success');
  };

  switch (page) {
    case 'start':
      return <NoAvailabilityPage onConfirm={() => setPage('confirm')} />;
    case 'confirm':
      return (
        <>
          <BookingHeader>{`${t(
            'Let_the_host_know_you\'d_like_to_schedule_a_meeting',
            'Let the host know you\'d like to schedule a meeting',
          )}.`}</BookingHeader>
          <BookingDetailsForm
            templateId={templateId}
            onSubmit={handleSubmit}
            color={color}
            buttonText={{
              init: t('Submit', 'Submit'),
              submitting: `${t('Submit', 'Submit')}...`,
              success: t('Success', 'Success'),
              error: t('Error', 'Error'),
            }}
          />
        </>
      );
    case 'success':
      return <NoAvailabilitySuccess />;
    default:
      return null;
  }
}
